import { render, staticRenderFns } from "./CreateTagDialog.vue?vue&type=template&id=73e35709&scoped=true"
import script from "./CreateTagDialog.vue?vue&type=script&lang=js"
export * from "./CreateTagDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTagDialog.vue?vue&type=style&index=0&id=73e35709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e35709",
  null
  
)

export default component.exports